import { ax } from './_ax';

const getCards = async (patientId) => {
  const res = await ax.get(`/mmj_cards?patient_id=${patientId}`);
  return res;
};

const createCard = async (payload) => {
  const res = await ax.post('/mmj_cards', payload);
  return res;
};

const updateCard = async (cardId, payload) => {
  const res = await ax.put(`/mmj_cards/${cardId}`, payload);
  return res;
};

const getPresignedUrl = async (filename, contentType) => {
  const res = await ax.post('/patient_documents/presign', {
    filename,
    content_type: contentType,
  });
  return res;
};

const getSignedViewUrls = async (urls) => {
  const encoded = encodeURIComponent(JSON.stringify(urls));
  const res = await ax.get(`/patient_documents/presign?urls=${encoded}`);
  return res;
};

const uploadToS3 = async (uploadUrl, file, contentType) => {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  });
  return res;
};

const mmjCardService = {
  getCards,
  createCard,
  updateCard,
  getPresignedUrl,
  getSignedViewUrls,
  uploadToS3,
};

export default mmjCardService;
